
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeed as ObiSpeedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed.js';
 
 
 

 
 export const ObiSpeed = createComponent({
   react: React,
   tagName: 'obi-speed',
   elementClass: ObiSpeedElement,
   events: {
     
   }
  });
 
 